module.exports = __webpack_public_path__ + "static/media/breadcrumbarrow.e391d812.svg";